import React, { useState } from 'react';
import ModalBase from '../ModalBase';

interface TextInputModalProps {
    isOpen: boolean;
    onClose: () => void;
    heading: string;
    defaultValue: string;
    confirmButtonText?: string;
    onConfirm: (value: string) => void;
}

const TextInputModal: React.FC<TextInputModalProps> = ({
    isOpen,
    onClose,
    heading,
    defaultValue,
    confirmButtonText = 'Confirm',
    onConfirm,
}) => {
    const [inputValue, setInputValue] = useState(defaultValue);

    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm(inputValue);
        onClose();
    };

    return (
        <ModalBase onClose={onClose}>
            <div className="confirmation-modal-content">
                <h2>{heading}</h2>
                <textarea
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    className="user-input-text-area"
                />
                <div className="button-row">
                    <button className="btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn-primary" onClick={handleConfirm}>
                        {confirmButtonText}
                    </button>
                </div>
            </div>
        </ModalBase>
    );
};

export default TextInputModal;
